import styled from 'styled-components';

export const TypingCountWrapper = styled.div`
  font-weight: 400;
  font-size: 1.4rem;
  color: ${(porps): string => porps.theme.palette.grey[300]};
`;

export const TypingCounter = styled.span``;
